import React, { useEffect, useState } from "react";
import { Outlet, matchPath, useLocation, useSearchParams } from "react-router-dom";
import { authService } from "../services";
import { brandingOf } from "../config/branding";
import { useI18n } from "../i18n";
import BrandMark from "../components/BrandMark";

const HIGHLIGHTS = [
  { th: "รวมลูกค้า แชท ออเดอร์ และการเงินไว้ในระบบเดียว", en: "Customers, chat, orders and finance in one place" },
  { th: "เปิด-ปิดโมดูลตามประเภทธุรกิจ รองรับ 18 โมเดล", en: "Toggle modules per business type, 18 models supported" },
  { th: "รับชำระเงินด้วย QR PromptPay พร้อมตรวจสลิปอัตโนมัติ", en: "Accept QR PromptPay with automatic slip verification" },
  { th: "ใช้ได้ทั้งเจ้าของธุรกิจ พนักงาน และลูกค้าปลายทาง", en: "Built for owners, staff and end customers" },
];

export default function AuthLayout() {
  const { t, tx } = useI18n();
  const location = useLocation();
  const [search] = useSearchParams();
  const [shop, setShop] = useState(null);

  // เข้าผ่านลิงก์สมัครของร้าน -> โหลดข้อมูลร้านมาแสดงแบรนด์ (ถ้าร้านมีสิทธิ์ White-label) · โหลดไม่ได้ = ใช้แบรนด์ปกติเงียบ ๆ
  const shopCode = (matchPath("/auth/register/customer/:shopCode", location.pathname)?.params.shopCode ||
    (matchPath("/auth/register/customer", location.pathname) ? search.get("shop") : "") ||
    "").toUpperCase();

  useEffect(() => {
    let alive = true;
    setShop(null);
    if (shopCode) {
      authService
        .shopByCode(shopCode)
        .then((row) => alive && setShop(row))
        .catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, [shopCode]);

  const brand = brandingOf(shop);

  return (
    <div className="auth-page" style={brand.cssVars}>
      <div className="auth-hero">
        <div className="u-flex u-gap-12" style={{ alignItems: "center" }}>
          <BrandMark brand={brand} size={44} />
          <div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>{brand.name}</div>
            {brand.custom ? null : <div style={{ fontSize: 12, color: "var(--muted)" }}>{t("app.tagline")}</div>}
          </div>
        </div>

        {brand.custom ? (
          <h2>{tx(`ยินดีต้อนรับสู่ ${brand.name}`, `Welcome to ${brand.name}`)}</h2>
        ) : (
          <>
            <h2>{tx("ระบบบริหารธุรกิจ ครบทุกโมเดล ในที่เดียว", "One system for every business model")}</h2>
            <p>
              {tx(
                "ตั้งแต่คลินิก ฟิตเนส ให้เช่ารถ อสังหาฯ ค้าปลีก ไปจนถึงแม่ค้าออนไลน์ — เปิดใช้เฉพาะโมดูลที่ธุรกิจคุณต้องการ",
                "From clinics and gyms to rentals, real estate, retail and online sellers — enable only the modules you need."
              )}
            </p>

            <ul className="auth-hero__list">
              {HIGHLIGHTS.map((item) => (
                <li key={item.th}>
                  <span>✓</span>
                  <span>{tx(item.th, item.en)}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>

      <div className="auth-form">
        <div className="auth-form__inner">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
